import { gql } from '@apollo/client';

export const CREATE_PRODUCT = gql`
  mutation CreateProduct($data: ProductCreateInput!) {
    createProduct(data: $data) {
      id
    }
  }
`;
export const UPDATE_PRODUCT = gql`
  mutation UpdateProduct($data: ProductUpdateInput!, $where: ProductWhereUniqueInput!) {
    updateProduct(data: $data, where: $where) {
      id
    }
  }
`;


export const CREATE_CART = gql`
  mutation CreateCart($data: CartCreateInput!) {
    createCart(data: $data) {
      id
      productId
      quantity
    }
  }
`;

export const UPDATE_CART = gql`
  mutation UpdateCart($data: CartUpdateInput!, $where: CartWhereUniqueInput!) {
    updateCart(data: $data, where: $where) {
      id
      productId
      quantity
    }
  }
`;

export const PRODUCTS = gql`
   query FindManyProduct($where: ProductWhereInput, $orderBy: [ProductOrderByWithRelationInput!]) {
    findManyProduct(where: $where, orderBy: $orderBy) {
      id
      drugName
      expDate
      ndc
      strength
      packaging
      wacDiscount
      price
      unitPrice
      quantity
      quantityPerPack
      userId
      createdAt
      type
      packageCondition
      sealDetails
      notes
      ProductPackages {
        Package {
          key
          name
        }
      }
    }
  }
`;

export const PRODUCTS_PAGINATED = gql`
  query FindManyProductPaginated($where: ProductWhereInput, $orderBy: [ProductOrderByWithRelationInput!], $skip: Int, $take: Int) {
    findManyProductPaginated(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
      products {
        id
        drugName
        expDate
        ndc
        strength
        packaging
        wacDiscount
        price
        unitPrice
        quantity
        quantityPerPack
        userId
        createdAt
        type
        packageCondition
        sealDetails
        notes
        ProductPackages {
          Package {
            key
            name
          }
        }
      }
      totalCount
    }
  }
`;

export const SELL_LIST_PAGINATED = gql`
  query FindManyProductPaginatedSellList(
    $where: ProductWhereInput
    $orderBy: [ProductOrderByWithRelationInput!]
    $skip: Int
    $take: Int
  ) {
    findManyProductPaginated(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
      products {
        id
        drugName
        expDate
        ndc
        strength
        quantityPerPack
        wacDiscount
        price
        unitPrice
        quantity
        lotNumber
        type
        isActive
        Pharmacy {
          id
          legalName
          PharmacyStatus {
            Status {
              key
            }
          }
        }
      }
      totalCount
    }
  }
`;

export const PRODUCT = gql`
   query FindUniqueProduct($where: ProductWhereUniqueInput!) {
    findUniqueProduct(where: $where) {
      id
      drugName
      expDate
      form
      isFrozen
      labelerName
      lotNumber
      ndc
      notes
      packageCondition
      sealDetails
      packaging
      pharmacyId
      price
      priceOption
      quantity
      quantityPerPack
      storage
      strength
      type
      wacDiscount
      unitPrice
      userId
      ProductPackages {
        Package {
          key
          name
        }
      }
      ProductShipping {
        ShippingMethod {
          key
          name
        }
      }
    }
  }
`;

export const POSTINGS = gql`
   query FindManyProduct($where: ProductWhereInput, $orderBy: [ProductOrderByWithRelationInput!]) {
    findManyProduct(where: $where, orderBy: $orderBy) {
      id
      drugName
      expDate
      ndc
      strength
      packaging
      wacDiscount
      price
      unitPrice
      quantity
      lotNumber
      quantityPerPack
      type
      isActive
      Pharmacy {
        id
        legalName,
        PharmacyStatus {
          Status {
            key
          }
        }
      }
    }
  }
`;

export const MY_SALES = gql`
   query FindManyProduct($where: ProductWhereInput, $orderBy: [ProductOrderByWithRelationInput!]) {
    findManyProduct(where: $where, orderBy: $orderBy) {
      id
      drugName
      expDate
      ndc
      strength
      packaging
      wacDiscount
      price
      unitPrice
      quantity
      lotNumber
      quantityPerPack
      type
      isActive
    }
  }
`;

export const UNIQUE_PRODUCT = gql`
  query FindUniqueProduct($where: ProductWhereUniqueInput!) {
    findUniqueProduct(where: $where) {
      id
      drugName
      expDate
      ndc
      strength
      packaging
      wacDiscount
      labelerName
      form
      price
      type
      isActive
      notes
      packageCondition
      sealDetails
      unitPrice
      quantity
      isFrozen
      lotNumber
      updatedAt
      quantityPerPack
      ProductPackages {
        id
        packageId
      }
      ProductShipping {
        id
        isPayable
        ShippingMethod {
          id
        }
      }
    }
  }
`
export const DELETE_PRODUCT = gql`
   mutation DeleteProduct($where: ProductWhereUniqueInput!) {
    deleteProduct(where: $where) {
      id
    }
  }
`;

export const PACKAGES = gql`
   query FindManyPackage {
    findManyPackage {
      key
      id
      name
    }
  }
`;

export const SHIPPING_METHODS = gql`
   query FindManyShippingMethod {
    findManyShippingMethod {
      key
      id
      name
    }
  }
`;

export const CART = gql`
   query FindManyCart($where: CartWhereInput) {
    findManyCart(where: $where) {
      id
      quantity
      productId
      createdAt
      Product {
        id
        drugName
        expDate
        ndc
        strength
        packaging
        wacDiscount
        labelerName
        isFrozen
        form
        price
        type
        notes
        packageCondition
        unitPrice
        quantity
        lotNumber
        updatedAt
        quantityPerPack
        sealDetails
        ProductPackages {
          id
          Package {
            id
            key
            name
          }
        }
        ProductShipping {
          ShippingMethod {
            id
            key
            name
          }
        }
        Pharmacy {
          id
          legalName
          mobile
          email
          PharmacyDetail {
            contractManager
            managerContactName
          }
          PharmacyAddress {
            address
            city
            zipCode
            State {
              code
              name
            }
          }
        }
        User {
          id
        }
      }
      User {
        PharmacyUsers {
          Pharmacy {
            id
            legalName
            mobile
            email
            PharmacyDetail {
              contractManager
              managerContactName
            }
            PharmacyAddress {
              address
              city
              zipCode
              State {
                code
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const DELETE_CART = gql`
   mutation DeleteCart($where: CartWhereUniqueInput!) {
    deleteCart(where: $where) {
      id
    }
  }
`;
export const DELETE_ALL_CART = gql`
   mutation DeleteCart($where: CartWhereInput!) {
    deleteManyCart(where: $where) {
      count
    }
  }
`;